import React, { memo } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { hasAuth, checkPermission } from './permissionWeb'
//import UnauthorizedPage from '../pages/Error/UnauthorizedWeb'

const WebLoginRoute = ({ userInfo, component: Component, ...rest }) => {
  if (hasAuth(userInfo)) {
    //if (checkPermission()) {
      return <Route {...rest} render={() => <Component />} />
    //}

    //return <Route {...rest} render={() => <UnauthorizedPage />} />
  }

  return <Route {...rest} render={(props) => <Redirect to={{ pathname: '/login', state: { from: props.location } }} />} />
  
}


export default WebLoginRoute
